module.exports = __webpack_public_path__ + "static/media/e3.24a14958.png";